/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The WebKey model module.
 * @module model/WebKey
 * @version 1.0.0
 */
export class WebKey {
  /**
   * Constructs a new <code>WebKey</code>.
   * @alias module:model/WebKey
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>WebKey</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WebKey} obj Optional instance to populate.
   * @return {module:model/WebKey} The populated <code>WebKey</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new WebKey();
      if (data.hasOwnProperty('_id'))
        obj._id = ApiClient.convertToType(data['_id'], 'String');
      if (data.hasOwnProperty('key'))
        obj.key = ApiClient.convertToType(data['key'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} _id
 */
WebKey.prototype._id = undefined;

/**
 * @member {String} key
 */
WebKey.prototype.key = undefined;

/**
 * @member {String} title
 */
WebKey.prototype.title = undefined;

/**
 * @member {String} description
 */
WebKey.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
WebKey.prototype.enabled = undefined;

/**
 * @member {String} created
 */
WebKey.prototype.created = undefined;

/**
 * @member {String} updated
 */
WebKey.prototype.updated = undefined;

